/**
 * ReviewerLayout — reviewer section. Migrated onto the shared AppShell (DEV-405).
 */
import { Outlet } from 'react-router-dom'
import AppShell from '../components/ui/AppShell'
import UserMenu from '../components/ui/UserMenu'
import { REVIEWER_NAV } from './navConfig'
import { useTypedNavigate, ROUTES } from '../lib/routing'
import { useUser } from '../contexts/UserContext'

const ReviewerLayout = () => {
  const navigate = useTypedNavigate()
  const { user, logout } = useUser()

  const handleLogout = () => {
    logout()
    navigate(ROUTES.public.login)
  }

  return (
    <AppShell
      nav={REVIEWER_NAV}
      homeTo="/review"
      footer={(collapsed) => (
        <UserMenu
          collapsed={collapsed}
          onLogout={handleLogout}
          userName={user?.full_name || 'User'}
          userOfficeName={user?.office?.name || 'Office'}
        />
      )}
    >
      <Outlet />
    </AppShell>
  )
}

export default ReviewerLayout
